import { render, staticRenderFns } from "./ExportFieldMapping.vue?vue&type=template&id=c1948b66&scoped=true"
import script from "./ExportFieldMapping.vue?vue&type=script&lang=js"
export * from "./ExportFieldMapping.vue?vue&type=script&lang=js"
import style0 from "./ExportFieldMapping.vue?vue&type=style&index=0&id=c1948b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1948b66",
  null
  
)

export default component.exports